<template>
  <footer>
    <div class="wrapper">
      <div class="notice">
        {{ $config.common.notice }}
      </div>
      <div class="licence decors-icons-mentions" />
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
};
</script>
<style lang="stylus" scoped>
footer {
  width: 100%;
  height: 100px;
  border-top: 1px solid white;
  color: var(--white, #FFF);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 1.68px;
  text-transform: uppercase;

  display: flex;
  align-items: center;

  .wrapper {
    width: 100%;
    max-width: $container-width;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
    position: relative;

    +mobile() {
      flex-direction: column-reverse;
      gap: 10px;
    }

    .licence {
      +desktop() {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
